import { classificationBadges } from "@/lib/classification";

export default function ClassificationBadges({ entity, testId = "classification-badges" }) {
  const badges = classificationBadges(entity);
  if (!badges.length) return null;
  return (
    <div className="mt-1 flex flex-wrap gap-1" data-testid={testId}>
      {badges.map((badge) => (
        <span
          key={`${badge.kind || "b"}-${badge.label}`}
          title={badge.title || (badge.verified ? "Verified" : badge.status || "Unverified")}
          data-verified={badge.verified ? "true" : "false"}
          className={
            badge.verified
              ? "rounded border border-emerald-400/40 bg-emerald-400/10 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-emerald-200"
              : "rounded border border-white/15 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-zinc-400"
          }
        >
          {badge.label}
        </span>
      ))}
    </div>
  );
}
